export enum IconWeight {
  Light = 'light',
  Regular = 'regular',
  Bold = 'bold',
}
